import type { UnavailableCardProps } from './remote';

export default function UnavailableCard({ remote, message }: UnavailableCardProps) @{
  <section role="alert" class="rounded-lg border border-[rgb(var(--color-border))] p-6 m-6" data-c-remote-pending={remote}>
    <h2 class="text-base font-semibold mb-2">This section is unavailable</h2>
    <p class="text-sm text-[rgb(var(--color-text-muted))]">{message}</p>
  </section>
}
